// component/FiltrerTransactionModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  ButtonGroup,
} from "reactstrap";
import '../utils/detail.css';
const FiltrerBusinessModal = ({ isOpen, toggle, onApply, countries = [] }) => {
  const [isActive, setIsActive] = useState("");
  const [selectedCountrie, setSelectedCountrie] = useState("");
  const [requestDate, setRequestDate] = useState("")
  const [approvalDate, setApprovalDate] = useState("")

  const applyFilters = () => {
    onApply({
      isActive,
      countrie: selectedCountrie,
      requestDate,
      approvalDate,
     
    });
    toggle();
  };

  return (
   <Modal isOpen={isOpen} toggle={toggle} contentClassName="custom-modal-siz-business" centered>
      <ModalHeader toggle={toggle} className="custom-modal-header"style={{color:'#000000'}}>
        Filtrer
      </ModalHeader>
      <ModalBody>
       <div className="mb-3">
      <div className="d-flex align-items-center me-3">
        <label className=" mb-0 me-2 lanel">Statut</label>
        <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
      </div>
      <ButtonGroup>
   <Button
  style={{
    backgroundColor: isActive === "" ? "#3761FF14" : "#0000000F",
    color: isActive === "" ? "#3761FF" : "#000000",
    border:isActive===""? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: isActive === "" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px'
  }}
  onClick={() => setIsActive("")}
>
  Tous
</Button>

    <Button
     style={{
        backgroundColor: isActive === true ? "#EBFFEA" : "#0000000F",
        color: isActive === true ? "#349C32" : "#000000",
        border:isActive === true ? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: isActive === true ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setIsActive(true)}
    >
      Activé
    </Button>

    <Button
     style={{
        backgroundColor: isActive === false ? "#FFF0F0" : "#0000000F",
        color: isActive === false ? "#E32727" : "#000000",
        border:isActive===false ? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: isActive === false ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setIsActive(false)}
    >
      Désactivé
    </Button>
  </ButtonGroup>
  </div>
   <div className="mb-3">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Pays</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
    <FormGroup className="col-4">
  <Input
  style={{margin:"10px"}}
    type="select"
    value={selectedCountrie}
    onChange={(e) => setSelectedCountrie(e.target.value)}
  >
    <option value="">Toutes</option>
    {countries.map((method, index) => (
      <option key={index} value={method}>
        {method.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase())}
      </option>
    ))}
  </Input>
</FormGroup>
    </div>
       <div className="mb-3">
         <div className="d-flex align-items-center me-3">
        <label className=" mb-0 me-2 lanel">Date de la demande</label>
        <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
      </div>
      <div className="col-4" style={{margin:"10px"}}>
        <FormGroup>
        <Input
          type="date"
          value={requestDate}
          onChange={(e) => setRequestDate(e.target.value)}
        />
      </FormGroup>
      </div>
       </div>
        <div className="mb-3">
         <div className="d-flex align-items-center me-3">
        <label className=" mb-0 me-2 lanel">date d'approbation</label>
        <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
      </div>
      <div className="col-4" style={{margin:"10px"}}>
        <FormGroup>
        <Input
          type="date"
          value={approvalDate}
          onChange={(e) => setApprovalDate(e.target.value)}
        />
      </FormGroup>
      </div>
       </div>
         
    <Button className="button apply-filter-btn"
     
      onClick={applyFilters}
    >
      Appliquer le filtre
    </Button>
      </ModalBody>
    </Modal>
  );
};

export default FiltrerBusinessModal;
